import {useEffect, useState} from 'react';

import {DialogActions, DialogContent, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {useLocation} from 'react-router-dom';

import CustomMappingsSpreadsheet from './CustomMappingsSpreadsheet';
import ToggleVisibleRowsSwitch from './ToggleVisibleRowsSwitch/ToggleVisibleRowsSwitch';
import useProjects from '../../../hooks/providers/useProjects';
import useProjectsCustomMappings from '../../../hooks/providers/useProjectsCustomMappings';
import Button from '../../form/buttons/Button/Button';
import BaseModal from '../../modal/BaseModal';
import Spinner from '../../spinner/Spinner';

// eslint-disable-next-line complexity
const CustomizeMappingModal = () => {
  const {closeProjectMenu, selectedProject: project} = useProjects();
  const {
    customizeMappingModalOpen: open,
    setCustomizeMappingModalOpen: setOpen,
    projectCustomMappings,
    getProjectCustomMappings,
    setResetCustomMappingsConfirmationModalOpen,
    updateProjectCustomMappings
  } = useProjectsCustomMappings();

  const [isResetting, setIsResetting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hiddenRowsVisible, setHiddenRowsVisible] = useState(false);

  const {siren} = project || {};

  const onClose = () => {
    closeProjectMenu();
    setOpen(false);
  };

  const handleSubmit = async () => {
    onClose();
    const updatedMappings = projectCustomMappings.get(siren);
    updateProjectCustomMappings(siren, updatedMappings);
  };

  useEffect(() => {
    (async () => {
      if (open && !projectCustomMappings?.has(siren)) {
        setIsLoading(true);
        await getProjectCustomMappings(siren);
        setIsLoading(false);
      }
    })();
  }, [open, siren]);

  const toggleHiddenRowsVisible = () => {
    setHiddenRowsVisible(!hiddenRowsVisible);
  };

  const location = useLocation();
  const isReportPage = location.pathname.startsWith('/reports');
  const allRequiredCellsAreFilled = siren ? (projectCustomMappings.get(siren) || []).every(item => item.mapping_name && item.mapping_sig) : false;

  return (
    <BaseModal
      shouldMatchEmbedReportWidth={isReportPage}
      overridesPaperProps={{margin: 0}}
      hasFullScreenButton
      hasCloseIcon
      maxWidth={false}
      title="Modifier l'affectation des comptes"
      onClose={onClose}
      open={open}
    >
      <DialogContent sx={{pl: 1}}>
        <ToggleVisibleRowsSwitch hiddenRowsVisible={hiddenRowsVisible} toggleHiddenRowsVisible={toggleHiddenRowsVisible} />
        <Spinner isLoading={isLoading} text="Chargement des données" />
        {projectCustomMappings?.has(siren) && !isLoading ? <CustomMappingsSpreadsheet hiddenRowsVisible={hiddenRowsVisible} /> : null}
      </DialogContent>

      <DialogActions
        sx={{
          mb: 1.5,
          width: '100%',
          flexDirection: 'column'
        }}
      >
        <Grid container justifyContent="center">
          <Button disabled={isResetting || isLoading || !allRequiredCellsAreFilled} variant="contained" color="success" onClick={handleSubmit} sx={{mr: 1}}>
            Mettre à jour
          </Button>
          <Button disabled={isResetting || isLoading} variant="contained" color="secondary" onClick={() => setResetCustomMappingsConfirmationModalOpen(true)}>
            Réinitialiser
          </Button>
        </Grid>
        {!allRequiredCellsAreFilled ? (
          <Typography mt={1} fontSize={13} color="error">
            Toutes les cellules “SIG" et "Catégorie" doivent être remplies
          </Typography>
        ) : null}
      </DialogActions>
    </BaseModal>
  );
};

export default CustomizeMappingModal;
